import React from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { currentInnerWidth, currentModalData, realEstateModalState, userIdSelector } from 'atoms';
import { useMutation, useQueryClient } from 'react-query';
import { realEstate } from 'fetchers/realEstateApi';

const RealEstate = ({ data }) => {
  const queryClient = useQueryClient();
  const innerWidth = useRecoilValue(currentInnerWidth);
  const userId = useRecoilValue(userIdSelector);
  const setIsRealEstateModalOpen = useSetRecoilState(realEstateModalState);
  const setModalData = useSetRecoilState(currentModalData);

  const { mutate } = useMutation((id) => realEstate.removeData(id), {
    onSuccess: () => {
      queryClient.invalidateQueries('realEstate');
    },
    onError: ({ response }) => window.alert(response.error.message),
  });

  const handleModifyButton = () => {
    setModalData(data);

    setIsRealEstateModalOpen((prev) => !prev);
  };

  const handleResetButton = async () => {
    if (window.confirm('삭제하시겠습니까?')) {
      mutate(data.id);
    } else {
      return;
    }
  };

  return (
    data && (
      <section className='px-4 pb-4 border-top-0 border-bottom border-bottom-1 border-bottom-gray'>
        <div className='row flex-nowrap no-gutters py-4 align-items-center'>
          <div className='col-2'>
            <div className='thumbnail-cover-1-1'>
              <img className='card-img m-0 rounded-circle' src={data.fileUrl} alt='Thumbnail' />
            </div>
          </div>
          <div className='col-10'>
            <div className='card-body py-0'>
              <div className='card-title row mb-1'>
                <h3 className='col font-weight-bold text-truncate-2'>{data.realestateName}</h3>
                <div className='col-auto ml-auto px-0 dropdown line-height-0'>
                  {userId === data.mUserID && (
                    <div data-toggle='dropdown' aria-haspopup='true' aria-expanded='true'>
                      <i className='i-more' />
                    </div>
                  )}
                  <ul
                    className='dropdown-menu dropdown-menu-right shadow-sm border-gray-200 py-2'
                    x-placement='bottom-end'
                  >
                    <li onClick={handleModifyButton}>
                      <div className='btn btn-link py-2 btn-block'>수정</div>
                    </li>
                    <li onClick={handleResetButton}>
                      <div className='btn btn-link py-2 btn-block'>삭제</div>
                    </li>
                  </ul>
                </div>
              </div>
              <ul className='card-text pl-0 text-gray-500'>
                <li className='text-truncate'>
                  <h5>대표 {data.providerName}</h5>
                </li>
                <li className='text-truncate'>
                  <small>{data.address}</small>
                </li>
                {data.homepage && (
                  <li className='text-truncate'>
                    <a href={`${data.homepage}`} target='_blank' rel='noreferrer'>
                      <small>홈페이지 바로가기</small>
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
        <div className='row mx-0'>
          <a type='button' className='col d-block ml-1 btn btn-outline-primary' href={`tel:${data.phone}`}>
            <div className='i-board-telephone-primary mr-1 align-middle'></div>
            {innerWidth >= 768 ? data.phone : '전화'}
          </a>
          <a type='button' className='col d-block ml-1 btn btn-outline-success' href={`sms:${data.phone}`}>
            <i class='bi bi-envelope mr-1' />
            문자
          </a>
        </div>
      </section>
    )
  );
};

export default RealEstate;
